export const DsfHomeUserCenter =dsf.defineAsyncComponent('DsfHomeUserCenter',()=>import(/*webpackChunkName:"platform_homepage"*/"./userCenter.vue"));
